import React, { useState, useEffect, useRef } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "./Notification.css";
import NotificationAlert from "./NotificationAlert";
import sound from "../../assets/sounds/sound.mp3";
import {
  useGetNotificationsByUserIdQuery,
  useUpdateNotificationMutation,
  useClearNotificationMutation,
  useReadNotificationMutation,
} from "./notificationSlice";
import { selectCurrentUser } from "./../auth/authSlice";
import { useSelector } from "react-redux";
import useInterval from "../../hooks/UseInterval";

const Notification = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [selectNotification, setSelectNotification] = useState();

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const user = useSelector(selectCurrentUser);

  const [updateNotification, { isLoading: updateNotificationIsLoading }] =
    useUpdateNotificationMutation();
  const [clearAllNotification, { isLoading: clearAllNotificationIsLoading }] =
    useClearNotificationMutation();
  const [readAllNotification, { isLoading: readAllNotificationIsLoading }] =
    useReadNotificationMutation();

  const {
    data: notificationsData,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetNotificationsByUserIdQuery(user.userID);

  useInterval(() => {
    refetch();
  }, 10000);

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (showAlert) {
      //const audio = new Audio(sound);
      // audio.play();
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }, [showAlert]);

  useEffect(() => {
    if (notificationsData) {
      const data = notificationsData.ids.map((id) => {
        if (!notificationsData.entities[id].isRead) {
          setShowAlert(true);
          setShowMessage(notificationsData.entities[id].message);
        }
        return notificationsData.entities[id];
      });
      setNotifications(data);
    }
  }, [notificationsData]);

  const notificationsByReadStatus = notifications.reduce(
    (acc, notification) => {
      const key = notification.isRead ? "read" : "unread";
      acc[key].push(notification);
      return acc;
    },
    { read: [], unread: [] }
  );

  const readNotification = async () => {
    try {
      await updateNotification(selectNotification).unwrap();
    } catch (err) {
      console.error("Failed to update the Notification", err);
    }
  };

  const onNotificationClicked = (param) => (e) => {
    const selectedNotification = { ...param };
    if (selectedNotification?.receiverStatus)
      selectedNotification.receiverStatus = "Read";
    setSelectNotification(selectedNotification);
    readNotification();
  };

  const onClearAllNotificationClicked = async () => {
    try {
      var notificationIds = notifications
        .filter((n) => n.isRead)
        .map((n) => {
          return n.notificationId;
        });
      if (notificationIds.length > 0) {
        await clearAllNotification({
          notificationIds,
        }).unwrap();
      }
    } catch (err) {
      console.error("Failed to update the Notifications", err);
    }
  };

  const onReadAllNotificationClicked = async () => {
    try {
      var notificationIds = notifications
        .filter((n) => !n.isRead)
        .map((n) => {
          return n.notificationId;
        });
      if (notificationIds.length > 0) {
        await readAllNotification({
          notificationIds,
        }).unwrap();
      }
    } catch (err) {
      console.error("Failed to update the Notifications", err);
    }
  };

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          className={`notification-btn d-flex alert-success-msg badge rounded-pill ${
            showAlert ? "show-alert" : ""
          }`}
        >
          <NotificationAlert show={showAlert} message={showMessage} />

          <span
            className={
              notificationsByReadStatus.unread.length > 0
                ? "icon-active"
                : "icon"
            }
          ></span>
        </DropdownToggle>
        <DropdownMenu className="p-3 mt-3 bg-nav border-0 shadow notification-panel">
          <div className="d-flex justify-content-between">
            <h5>Notifications</h5>
            <span className="primary-text">
              (Latest: <strong>{notifications.length}</strong>)
            </span>
          </div>
          <DropdownItem divider />

          {notifications.length > 0 ? (
            <>
              <div className="over px-2">
                {notificationsByReadStatus.unread.map((notification) => (
                  <DropdownItem
                    key={notification.notificationId}
                    className="notification text-wrap rounded mb-2 latest"
                  >
                    <div className="d-flex justify-content-between">
                      <small>{notification.notificationDate}</small>
                      <small>{notification.notificationTime}</small>
                    </div>
                    <p
                      className="m-0 p-1"
                      style={
                        notification.isRead
                          ? { fontWeight: "normal" }
                          : { fontWeight: "bold" }
                      }
                      //onClick={(event) => onNotificationClicked(event, notification.notificationId)}
                      onClick={onNotificationClicked(notification)}
                    >
                      {notification.description}
                    </p>
                  </DropdownItem>
                ))}
                <DropdownItem divider />
                {notificationsByReadStatus.read.map((notification) => (
                  <DropdownItem
                    key={notification.notificationId}
                    className="notification text-wrap rounded mb-2"
                  >
                    <div className="d-flex justify-content-between">
                      <small>{notification.notificationDate}</small>
                      <small>{notification.notificationTime}</small>
                    </div>
                    <p className="m-0 p-1">{notification.description}</p>
                  </DropdownItem>
                ))}
              </div>
              <DropdownItem divider />
              <div className="row px-1">
                <div className="col-sm-12 col-md-6">
                  <button
                    className="btn bg-main text-danger w-100 mt-2"
                    onClick={onClearAllNotificationClicked}
                    disabled={clearAllNotificationIsLoading}
                  >
                    {clearAllNotificationIsLoading
                      ? "Clearing..."
                      : "Clear All Read"}
                  </button>
                </div>
                <div className="col-sm-12 col-md-6">
                  <button
                    className="btn btn-gradient w-100 mt-2"
                    onClick={onReadAllNotificationClicked}
                  >
                    {readAllNotificationIsLoading
                      ? "Marking..."
                      : "Mark All as Read"}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p className="text-center py-1 m-0 primary-text">
              There's nothing to show at the moment!
            </p>
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default Notification;
